"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("circle", { cx: "33.5", cy: "22.404", r: "3.094" }),
  React.createElement("path", { d: "M46 12H10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zm-2 4v21.311c-1.92-2.034-5.14-4.645-6.682-4.583-2.409 0-5.5 4.006-8.752 4.006-2.2 0-5.367-7.519-7.839-7.519S14.478 32.587 12 35.7V16z" }),
  React.createElement("path", { d: "M4 8h36V6a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h2z" })
);

